module.exports = __webpack_public_path__ + "img/compensationrupee.1f7f4a27.svg";